import React, {Component} from 'react';
import List, {ListItem} from 'material-ui/List';
import Paper from 'material-ui/Paper';
import dateformat from 'dateformat';

class Pagos extends Component {
    render() {
        if (!this.props.show) return null;
        
        const detallepagos = this.props.pedido.pagos.map((pago) => {
            return (
                <ListItem disableTouchRipple={true} key={pago.id} style={{lineHeight:1.3}}>
                    <div><strong>Fecha: </strong> <span>{dateformat(new Date(pago.fecha).toGMTString(), 'UTC:dd-mm-yyyy')}</span></div> 
                    
                    
                    <div><strong>Tipo:</strong>  <span>{pago.tipo.descripcion}</span>
</div> 
                   
                    <div><strong>Monto:</strong> <span>{parseFloat(pago.monto).bs()}</span></div>
                    <div>
                        <strong>Status:</strong> 
                        <span style={{color: pago.verificado ? 'green' : 'red'}}> {pago.verificado ? 'Verificado' : 'Sin Verificar'}</span>
                    </div>
                    
                </ListItem>
            );
        });

        return (
            <ListItem 
                innerDivStyle={{padding:20}}
                primaryTogglesNestedList={true} 
                primaryText="Ver pagos realizados" 
                nestedItems={detallepagos || <p>Aún no ha cargado ningún pago...</p>}>              
            </ListItem>
        );
    }
}

export default Pagos;


/** WEBPACK FOOTER **
 ** ./app-react/components/Suscripcion/Pagos.jsx
 **/